import { TokenIcons } from '../../../assets/icons';
import Card from '../../../components/Card';
import { TradePair } from '../../../context/chart/chartTypes';
import {
    chartSymbolToRouteParam,
    formatAmountWithSuffix,
    formatPercentages,
    formatUSD,
} from '../../../helpers';
import useTokenStats from '../../../hooks/web3/useTokenStats';
import useMockVolume from '../../../hooks/web3/trade/useMockVolume';

type TradingCardProps = {
    pool: TradePair;
};

type VolumeProps = {
    pool: TradePair;
};

const TradingCard: React.FC<TradingCardProps> = ({ pool }) => {
    const tokenStats = useTokenStats();

    const tokenStat = tokenStats?.[pool.chartSymbol];

    return (
        <Card
            to={`/trade/${chartSymbolToRouteParam(pool.chartSymbol, false)}`}
            variant='secondary'
        >
            <div className='token'>
                {TokenIcons[pool.asset.symbol] ?? TokenIcons.FALLBACK}
                <div className='token-info'>
                    <div className='token-name'>{pool.asset.name}</div>
                    <div className='token-symbol'>{pool.asset.symbol}</div>
                </div>
            </div>
            <div className='trade-detail'>
                <div className='token-value'>
                    {tokenStat
                        ? `$ ${formatUSD(tokenStat?.price || 0, {
                              currency: '',
                              minDecimals: 2,
                              //   maxDecimals: pool.decimalFormatting,
                          })}`
                        : '-'}
                </div>
                <div className='trade-info'>
                    <div className='change'>
                        <div className='title'>CHG</div>
                        <div
                            className={`value ${
                                tokenStat
                                    ? tokenStat?.priceChangePercent > 0
                                        ? 'increased'
                                        : 'decreased'
                                    : ''
                            }`}
                        >
                            {tokenStat ? (
                                <>
                                    {tokenStat?.priceChangePercent > 0 ? '+' : null}
                                    {formatPercentages(
                                        tokenStat?.priceChangePercent || 0,
                                        2
                                    )}
                                    %
                                </>
                            ) : (
                                '-'
                            )}
                        </div>
                    </div>
                    <Volume pool={pool} />
                </div>
            </div>
        </Card>
    );
};

export default TradingCard;

const Volume: React.FC<VolumeProps> = ({ pool }) => {
    // const { dailyVolume } = useDailyVolume();
    const { volume } = useMockVolume();

    return (
        <div className='volume'>
            <div className='title'>VOL</div>
            <div className='value'>
                {formatAmountWithSuffix(volume[pool.chartSymbol] ?? 0, {
                    minDecimals: 2,
                })}
                {/* {dailyVolume
                    ? `$
                            ${formatAmountWithSuffix(dailyVolume[pool.address] || 0, {
                                minDecimals: 2,
                            })}`
                    : '-'} */}
            </div>
        </div>
    );
};
